import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import { withTranslation } from 'react-i18next';

export class HelpButtonClass extends Component {
    render() {
        const { t } = this.props;
        return (
            <div className={"help-center-icon"}>
                <a href="https://ayuda.dashbo.io" rel="noopener noreferrer" target="_blank">
                    <FaIcon iconName="question"/><span className="tooltip-text">{t('help_button.help_center')}</span>
                </a>
            </div>
        );
    }
}

export const HelpButton = withTranslation()(HelpButtonClass);
export default HelpButton;
